<div *ngTemplateOutlet="planningItem?.template"></div>
